import firebase from "firebase";
import _ from "lodash";
import {getChildList} from "../utils/getChild";
import {getProjectByPlan} from "./plan";


export const getDir = async (id, projectID, init = false, planId, versionID = null) => {
  let name;

  const subDoc = await getProjectByPlan(projectID, planId, versionID)
    .collection('dirs').get()
  const objects = []

  subDoc.forEach((subDoc) => {
      const data = subDoc.data();
      objects.push({
        id: subDoc.id,
        name: data.name,
        objects: data.objects,
        index: data.index,
        parentId: data.parentId || undefined,
        isParent: data.isParent,
      });
    });

  const formatObjects = getChildList(objects);
  const object = formatObjects.find((o) => o.id === id);

  if (init) {
    return object;
  }

  return object.name;
}

export const fetchDirsWithParent = async (id, projectID, planID = null, versionID = null) => {
  const obj = await getDir(id, projectID, true, planID, versionID);

  if(!obj) return null
  return {
    id: obj.id,
    name: obj.name,
    objects: obj.objects,
    parentId: obj.parentId || undefined,
    isParent: !!obj.isParent,
  }
}

export const getDirOptions = async (id, init) => {
  const result = [];
  const objectsData = await myFirestore
    .collection('projects')
    .doc(id)
    .collection('dirs')
    .get();

  await objectsData.forEach((subDoc) => {
    const data = subDoc.data();
    result.push({
      id: subDoc.id,
      name: data.name,
      objects: data.objects,
      index: data.index,
      parentId: data.parentId || undefined,
      isParent: data.isParent,
    });
  });

  const r = _.orderBy(getChildList(result), 'index', ['asc']);
  if(init) {
    return  [
      ...r.map((r) => {
        return {
          label: r.name,
          value: r.id,
        };
      })
    ]
  }

  return [
    {
      label: 'Не выбрано',
      id: null,
    },
    ...r.map((r) => {
      return {
        label: r.name,
        value: r.id,
      };
    })
  ];
}



// WEBPACK FOOTER //
// ./src/firestore/dirs.js